import { OPERATOR_TIMEZONE } from '../shared/portalToday'

export function officeHoursTime(value, language, unavailable) {
  // Offset-free timestamps would silently use the viewer's timezone.
  if (typeof value !== 'string' || !/(?:Z|[+-]\d{2}:\d{2})$/.test(value)) return unavailable
  const instant = new Date(value)
  if (!Number.isFinite(instant.getTime())) return unavailable
  try {
    return new Intl.DateTimeFormat(language === 'cn' ? 'zh-CN' : 'en-GB', {
      timeZone: OPERATOR_TIMEZONE,
      year: 'numeric', month: 'short', day: 'numeric',
      hour: '2-digit', minute: '2-digit', hour12: false,
    }).format(instant)
  } catch {
    return unavailable
  }
}

export function safeOfficeHoursLink(value) {
  try {
    const link = new URL(value)
    return link.protocol === 'https:' && link.hostname && !link.username && !link.password ? link.href : null
  } catch {
    return null
  }
}

export function newOfficeHoursMutationId() {
  // Secure IDs only. A missing secure generator disables submission.
  return `ci1_${globalThis.crypto.randomUUID().replaceAll('-', '')}`
}
